import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";

const RenderJobDescriptionHTMLComponent = (props) => {
  const html = props?.htmlString;
  const theme = useTheme();
  const isMediumOrLarger = useMediaQuery(theme.breakpoints.up('md'));
  const fontSize = isMediumOrLarger ? "14px" : "12px";

  const tempContainer = document.createElement("div");
  tempContainer.innerHTML = html;

  const listItems = tempContainer.querySelectorAll("li");

  listItems.forEach((item) => {
    item.style.pageBreakInside = "avoid";
    item.style.fontFamily = "Poppins, Helvetica, Arial, sans-serif";
    item.style.fontSize = fontSize;
  });

  const listItems2 = tempContainer.querySelectorAll("p");

  listItems2.forEach((item) => {
    item.style.fontFamily = "Poppins, Helvetica, Arial, sans-serif";
    item.style.fontSize = fontSize;
  });

  const updatedHtmlString = tempContainer.innerHTML;

  return (
    <Box
      sx={{
        fontSize: { xs: '12px', md: '14px' },
        fontFamily: "Poppins, Helvetica, Arial, sans-serif"
      }}
      dangerouslySetInnerHTML={{ __html: updatedHtmlString }}
    />
  );
};

export default RenderJobDescriptionHTMLComponent;
